import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AccountsService } from '../services/account.service';
import { TokensDto } from '@bugz-mono/shared-dtos';
import { Router } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  constructor(
    private accountsService: AccountsService,
    private router: Router,
    private snackbarService: SnackbarService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip auth for refresh-token endpoint to prevent infinite loop
    if (req.url.includes('/refresh-token')) {
      return next.handle(req);
    }

    const token = this.accountsService.getAccessToken();
    let authReq = req;
    if (token) {
      authReq = this.addTokenToRequest(req, token);
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handle401Error(authReq, next);
        }
        return throwError(() => error);
      })
    );
  }

  private addTokenToRequest(req: HttpRequest<any>, token?: string) {
    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    // Prevent multiple simultaneous refresh attempts
    if (this.isRefreshing) {
      return this.refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => {
          return next.handle(this.addTokenToRequest(request, token!));
        })
      );
    }

    this.isRefreshing = true;
    this.refreshTokenSubject.next(null);

    return this.accountsService.refreshTokens().pipe(
      switchMap((newAccessToken) => {
        this.isRefreshing = false;
        this.accountsService.storeToken(
          newAccessToken.accessToken,
          newAccessToken.refreshToken
        );
        this.refreshTokenSubject.next(newAccessToken.accessToken?.toString());

        return next.handle(
          this.addTokenToRequest(request, newAccessToken.accessToken)
        );
      }),
      catchError((error) => {
        this.isRefreshing = false;
        this.logout();
        return throwError(() => error);
      })
    );
  }

  private logout() {
    // this.accountsService.logout();
    this.router.navigate(['/login']);
    this.snackbarService.showMessage(
      'error',
      'Session Expired',
      'Please log in again.'
    );
  }
}

// import { Injectable } from '@angular/core';
// import {
//   HttpEvent,
//   HttpHandler,
//   HttpInterceptor,
//   HttpRequest,
//   HttpErrorResponse,
// } from '@angular/common/http';
// import { BehaviorSubject, Observable, throwError } from 'rxjs';
// import { catchError, filter, switchMap, take } from 'rxjs/operators';
// import { AccountsService } from '../services/account.service';
// import { TokensDto } from '@bugz-mono/shared-dtos';
// import { Router } from '@angular/router';
// import { SnackbarService } from '../services/snackbar.service';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   private isRefreshing = false;
//   private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

//   constructor(
//     private accountsService: AccountsService,
//     private router: Router,
//     private snackbarService: SnackbarService
//   ) {}

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     const token = this.accountsService.getAccessToken();
//     let authReq = req;
//     if (token) {
//       authReq = this.addTokenToRequest(req, token);
//     }

//     return next.handle(authReq).pipe(
//       catchError((error: HttpErrorResponse) => {
//         if (error.status === 401) {
//           return this.handle401Error(authReq, next);
//         }
//         return throwError(() => error);
//       })
//     );
//   }

//   private addTokenToRequest(req: HttpRequest<any>, token?: string) {
//     return req.clone({
//       setHeaders: { Authorization: `Bearer ${token}` }
//     });
//   }

//   private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
//     return this.accountsService.refreshTokens().pipe(
//       switchMap((newAccessToken) => {
//         this.accountsService.storeToken(newAccessToken.accessToken, newAccessToken.refreshToken);
//         request = request.clone({
//           setHeaders: {
//             Authorization: `Bearer ${newAccessToken?.accessToken}`,
//           },
//         });

//         return next.handle(request);
//       }),
//       catchError((error) => {
//         this.logout();
//         return throwError(() => error);
//       })
//     );
//   }

//   private logout() {
//     // this.accountsService.logout();
//     this.router.navigate(['/login']);
//     this.snackbarService.showMessage('error', 'Session Expired', 'Please log in again.');
//   }
// }

// // export class AuthInterceptor implements HttpInterceptor {
// //   constructor(
// //     private accountsService: AccountsService,
// //     private router: Router,
// //     private snackbarService : SnackbarService,
// //   ) {}

// //   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
// //     const token = this.accountsService.getAccessToken();
// //     let authReq = req;
// //     if (token) {
// //       authReq = req.clone({
// //         setHeaders: { Authorization: `Bearer ${token}` },
// //       });
// //     }

// //     return next.handle(authReq).pipe(
// //       catchError((error: HttpErrorResponse) => {
// //         if (error.status === 401 ) {
// //           this.accountsService.refreshTokens().subscribe({
// //             next: (res) => {
// //               const authToken = res?.accessToken;
// //               if(authToken){
// //                 window.localStorage.setItem('authToken', authToken);
// //                 this.accountsService.accessToken= authToken;
// //               }
// //               const refreshToken = res?.refreshToken;
// //               if(refreshToken){
// //                   window.localStorage.setItem('refreshToken', refreshToken);
// //                   this.accountsService.refreshToken= res?.refreshToken;
// //               }

// //               const retryReq = req.clone({
// //                 setHeaders: { Authorization: `Bearer ${authToken}` },
// //               });
// //               return next.handle(retryReq);
// //             },
// //             error: (err) => {
// //               this.snackbarService.showMessage('error',"Failure",err.message);
// //             },
// //             complete: () => {

// //             }
// //           });
// //         }
// //         return throwError(() => error);
// //       })
// //     );
// //   }
// // }
